<div class="w-full p-4 md:p-12 select-none" *transloco="let t; prefix: 'userPage'">
    
    <div class="text-title text-quaternary mb-4">{{t('preference')}}</div>
    <div class="grid gap-4">
        
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeZoom')}}</div>
            <std-select (onChangeValue)="changeZoom($event)" customClassContaier="w-60 mr-4" [data]="zoomAvailable"
                [currentValue]="currentZoom"></std-select>
        </div>
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('invertColors')}}</div>
            <std-toggle [id]="'toggle-theme'" (onValueChange)="invert($event)" [checked]="invertColors"></std-toggle>
        </div>
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeColors')}}</div>
            <!-- <std-select (onChangeValue)="changeColors($event)" customClassContaier="w-60 mr-4" [data]="accessibilityThemes"
                [currentValue]="currentAccebilityTheme"></std-select> -->
                <std-slider [min]="100" [max]="300" [step]="1" [value]="currentContrast" id="contrast-slider" (onValueChange)="changeColors($event)"></std-slider>
        </div>
        <!-- <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('darkMode')}}</div>
            <std-toggle [id]="'toggle-theme'" (onValueChange)="changeTheme()" [checked]="darkMode"></std-toggle>
        </div> -->
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeLanguage')}}</div><std-select
                customClassContaier="w-60" (onChangeValue)="changeLanguage($event)" [data]="languages"
                [currentValue]="currentLanguage"></std-select>
        </div>
    </div>
    <div (click)="logout()" class="text-title text-quaternary mt-4 cursor-pointer">{{t('logout')}}</div>
</div>